import { Role } from "@/interfaces/Role";
import { RouteRecordRaw } from "vue-router";
import LoginLayout from "@/layouts/LoginLayout.vue";

export const guestRoutes: RouteRecordRaw[] = [
  {
    path: "/login",
    component: LoginLayout,
    children: [
      {
        path: "",
        name: "Login",
        component: () => import("@/views/Login/Login.vue"),
        meta: { requiresAuth: false, role: Role.Guest },
      },
    ],
  },
  {
    path: "/auth/callback",
    name: "ShopifyCallback",
    component: () => import("@/views/Auth/ShopifyCallback.vue"),
    meta: { requiresAuth: false },
  },
];
